<template>
  <div>
    <a-table ref="table" size="middle" :scroll="{ x: 1200 }" :pagination="false" row-key="id" :columns="columns" :data-source="dataSource">
      <span slot="customerTitle" slot-scope="text, record">
        <a-tooltip placement="top" :title="record.title">
          <a class="custom-link" :href="requirementLink(record.id)" target="_blank"> {{ record.title }} </a>
        </a-tooltip>
      </span>
      <span slot="status" slot-scope="text, record">
        <a-badge :status="storyStatus[record.status].status" :text="storyStatus[record.status].label" />
      </span>
      <span slot="version" slot-scope="text, record">
        <a href="">{{ record.version_title }}</a>
      </span>
      <span slot="priority" slot-scope="text, record">{{ record.priority ? `P${record.priority}` : '--' }}</span>
      <span slot="type" slot-scope="text, record">
        <a-badge v-if="record.requirement_type" :color="storyTypes[record.requirement_type].color" :text="storyTypes[record.requirement_type].label" />
        <span v-else>--</span>
      </span>
    </a-table>
  </div>
</template>

<script>
import { storyStatus, storyTypes, storyPrioritys } from '@/utils/dictionary';

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 92,
    customRender: (_text, _row) => {
      return 'PR-' + _text;
    }
  },
  {
    title: '标题',
    dataIndex: 'title',
    key: 'title',
    ellipsis: true,
    width: 300,
    scopedSlots: { customRender: 'customerTitle' }
  },
  {
    width: 160,
    ellipsis: true,
    title: '所属迭代',
    dataIndex: 'version_title',
    customRender: text => text || '--'
  },
  {
    width: 145,
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '需求类型',
    dataIndex: 'requirement_type',
    key: 'requirement_type',
    width: 110,
    scopedSlots: { customRender: 'type' }
  },
  {
    title: '优先级',
    dataIndex: 'priority',
    key: 'priority',
    width: 80,
    scopedSlots: { customRender: 'priority' }
  },
  {
    title: '产品',
    width: 120,
    ellipsis: true,
    dataIndex: 'pm',
    customRender: text => (text && text.length > 0 ? text.map(user => user.nickname).join('; ') : '--')
  },
  {
    title: '运营',
    width: 120,
    ellipsis: true,
    dataIndex: 'om',
    customRender: text => (text && text.length > 0 ? text.map(user => user.nickname).join('; ') : '--')
  },
  {
    title: '开始时间',
    width: 120,
    dataIndex: 'start_time',
    customRender: text => text || '--'
  },
  {
    title: '结束时间',
    width: 120,
    dataIndex: 'end_time',
    customRender: text => text || '--'
  }
];
export default {
  props: {
    dataSource: {
      type: [Array],
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      columns,
      storyTypes,
      storyStatus,
      storyPrioritys,
      storyData: {}
    };
  },
  computed: {
    requirementLink() {
      return id => {
        const route = this.$router.resolve({
          name: 'page:project:story:detail',
          query: { storyId: id }
        });
        return route.href;
      };
    }
  }
};
</script>

<style lang="less" scoped>
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}

.custom-link:hover {
  color: #1890ff;
}
</style>
